export default __webpack_public_path__ + "static/media/100.3436f9a4.jpg";